module.exports = __webpack_public_path__ + "static/media/qr.5cff2869.png";